import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../../apiCalls/category";
import { FiPlus, FiMinus } from "react-icons/fi";
import { FaTimes } from "react-icons/fa";
import Backdrop from "./Backdrop";
import SideDrawer from "./Sidedrawer";
import { navbarList } from "../../assets/data/navbardata";
import { Link } from "react-router-dom";

import { BsFacebook, BsTwitter, BsInstagram, BsLinkedin } from "react-icons/bs";
import { IoMenuOutline, IoHomeOutline } from "react-icons/io5";
import { BiHeart, BiShoppingBag, BiUser } from "react-icons/bi";

const MobileNavbar = () => {
  const cart = useSelector((state) => state.cart.products);
  const category = useSelector((state) => state.categories.categories);
  const wishlist = useSelector((state) => state.wishlist.products);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchCategories(dispatch);
  }, [dispatch]);

  const [drawerIsOpen, setDrawerIsOpen] = useState(false);
  const OpenDrawerHandler = () => {
    setDrawerIsOpen(true);
  };

  const closeDrawerHandler = () => {
    setDrawerIsOpen(false);
  };

  const [clicked, setClicked] = useState(false);

  const toggle = (index) => {
    if (clicked === index) {
      //if clicked question is already active, then close it
      return setClicked(null);
    }

    setClicked(index);
  };

  return (
    <>
      {drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}

      <SideDrawer show={drawerIsOpen}>
        <div className="mobile-navbar">
          <nav className="mobile-navigation-menu">
            <div className="menu-top title">
              <h2 className="menu-title">Menu</h2>

              <button className="menu-close-btn" onClick={closeDrawerHandler}>
                <FaTimes />
              </button>
            </div>

            <ul className="mobile-menu-category-list">
              <li className="menu-category">
                <Link
                  to="/"
                  className="menu-title"
                  onClick={closeDrawerHandler}
                >
                  Home
                </Link>
              </li>

              <li className="menu-category">
                <Link
                  to="/products"
                  className="menu-title"
                  onClick={closeDrawerHandler}
                >
                  Shop
                </Link>
              </li>

              {/* {navbarList.map((item, index) => {
                return (
                    <li
                      className="menu-category"
                      onClick={() => toggle(index)}
                      key={index}
                    >
                      <button className="accordion-menu">
                        <p className="menu-title">{item.catname}</p>

                        <div>
                          {clicked === index ? (
                            <FiMinus className="cat-icon" />
                          ) : (
                            <FiPlus className="cat-icon" />
                          )}
                        </div>
                      </button>

                      {clicked === index ? (
                        <ul className="submenu-category-list">
                          {item.subcategory.map((subcat, index) => {
                            return (
                              <>
                                <li className="submenu-category">
                                  <Link
                                    to="/"
                                    className="submenu-title"
                                    onClick={closeDrawerHandler}
                                    key={index}
                                  >
                                    {subcat.subcatname}
                                  </Link>
                                </li>
                              </>
                            );
                          })}
                        </ul>
                      ) : null}
                    </li>
                  // </>
                );
              })} */}
           
                  <li
                      className="menu-category"
                      onClick={() => toggle(true)}
                    >
                       <button className="accordion-menu">
                        <p className="menu-title">Categories</p>

                        <div>
                          {clicked === true ? (
                            <FiMinus className="cat-icon" />
                          ) : (
                            <FiPlus className="cat-icon" />
                          )}
                        </div>
                      </button>
                      {clicked === true ? (
                        <ul className="submenu-category-list">
                          {category.map((catData, index) => {
                            return (
                              <>
                                <li className="submenu-category">
                                  <a
                                    href={`/products/${catData?._id}`}
                                    className="submenu-title"
                                    onClick={closeDrawerHandler}
                                    key={index}
                                  >
                                    {catData.categoryname}
                                  </a>
                                </li>
                              </>
                            );
                          })}
                        </ul>
                      ) : null}
                    </li>
               

              <li className="menu-category">
                <Link
                  to="/"
                  className="menu-title"
                  onClick={closeDrawerHandler}
                >
                  Blog
                </Link>
              </li>

              <li className="menu-category">
                <Link
                  to="/"
                  className="menu-title"
                  onClick={closeDrawerHandler}
                >
                  Hot Offers
                </Link>
              </li>
            </ul>

            <div>
              <ul className="mobile-social-container">
                <li>
                  <a href="https://www.facebook.com/rohityadav5159" className="social-link">
                    <BsFacebook />
                  </a>
                </li>

                <li>
                  <a href="#" className="social-link">
                    <BsTwitter />
                  </a>
                </li>

                <li>
                  <a href="https://www.instagram.com/rohityadav5159/" className="social-link">
                    <BsInstagram />
                  </a>
                </li>

                <li>
                  <a href="https://www.linkedin.com/in/rohit-yadav-b78394168/" className="social-link">
                    <BsLinkedin />
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </SideDrawer>

      <div className="mobile-bottom-navigation">
        <button className="action-btn" onClick={OpenDrawerHandler}>
          <IoMenuOutline />
        </button>

        <Link to="/cart">
          <button className="action-btn">
            <BiShoppingBag />

            <span className="count">{cart[0]?.cartItems?.length ? cart[0]?.cartItems?.length : 0}</span>
          </button>
        </Link>

        <Link to="/" className="action-btn">
          <IoHomeOutline />
        </Link>

        <Link to="/wishlist">

        <button className="action-btn">
          <BiHeart />

          <span className="count">  {wishlist[0]?.listItems?.length
                        ? wishlist[0]?.listItems?.length
                        : 0}</span>
        </button>
        </Link>

        <Link to="/my-account">
          <button className="action-btn">
            <BiUser />
          </button>
        </Link>
      </div>
    </>
  );
};

export default MobileNavbar;
